/**
 * Created by Mark on 17/04/2017.
 */


import ENVIRONMENT_CONSTANTS from './environment.js'

export default {
    GET_ALL_CURRICULUMS: ENVIRONMENT_CONSTANTS.BASE_URL + '/packageController/getCurriculumWidthData',
    UPDATE_ALL_CURRICULUMS :'UPDATE_ALL_CURRICULUMS',
    GET_CURRICULUM_DATA:ENVIRONMENT_CONSTANTS.BASE_URL + '/packageController/getCurriculumData',
    GET_CURRICULUMS: ENVIRONMENT_CONSTANTS.BASE_URL + '/packageController/getCurriculums',
}



// WEBPACK FOOTER //
// ./src/constants/curriculum.js